import React from "react";
import StatsWidget from "@/components/dashboard/StatsWidget";
import StatsWithAreaChart from "@/components/dashboard/charts/StatsWithAreaChart";
import StatsWithPieChart from "@/components/dashboard/charts/StatsWithPieChart";
import StatsWithSingleChart from "@/components/dashboard/charts/StatsWithSingleChart";
import AssistentesTable from "@/components/dashboard/tables/AssistentesTable";
import CampaignsTable from "@/components/dashboard/tables/CampaignsTable";
import DashboardAlertBanner from "@/components/dashboard/DashboardAlertBanner";
import { useDashboard } from "@/hooks/useDashboard";
import { useConnectionAlerts } from "@/hooks/useConnectionAlerts";

const Dashboard: React.FC = () => {
  const {
    stats,
    messagesByDay,
    messagesByType,
    topAssistants,
    topCampaigns,
    loading,
    error
  } = useDashboard();

  const alerts = useConnectionAlerts();

  if (error) {
    return (
      <div className="w-full flex flex-col items-center justify-center h-[50vh]">
        <div className="text-center">
          <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.464 0L4.35 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <h3 className="text-lg font-semibold text-neutral-50 mb-2">Erro ao carregar dashboard</h3>
          <p className="text-neutral-300 text-sm">{error}</p>
        </div>
      </div>
    );
  }

  const statsWidgetData = [
    {
      name: "Contatos",
      value: stats.totalContacts.toLocaleString(),
    },
    {
      name: "Mensagens",
      value: stats.totalMessages.toLocaleString(),
    },
    {
      name: "Assistentes Ativos",
      value: stats.activeAssistants.toString(),
    },
    {
      name: "Campanhas Ativas",
      value: stats.activeCampaigns.toString(),
    },
  ];

  return (
    <div className="w-full flex flex-col">
      {!alerts.loading && (
        <DashboardAlertBanner
          whatsappDisconnected={alerts.whatsappDisconnected}
          openaiMissing={alerts.openaiMissing}
        />
      )}
      <div className="flex gap-3 justify-center xl:justify-start items-center flex-wrap">
        {statsWidgetData.map((item, index) => {
          return (
            <StatsWidget 
              key={index} 
              value={item.value} 
              name={item.name} 
              loading={loading}
            />
          );
        })}
      </div>
      <div className="w-full gap-4 mt-[24px] border-[1px] border-[#3F3F464D] rounded-[12px] p-5 grid grid-cols-1 2xl:grid-cols-2">
        <div className="w-full grid gap-4 grid-cols-1 lg:grid-cols-2">
          {/* Area chart -------------------------> */}
          <StatsWithAreaChart 
            data={messagesByDay} 
            loading={loading}
            totalMessages={stats.weekMessages}
          />
          <StatsWithPieChart 
            data={messagesByType} 
            loading={loading}
          />
        </div>
        <StatsWithSingleChart 
          data={messagesByDay} 
          loading={loading}
        />
      </div>
      <div className="w-full gap-4 mt-6 grid grid-cols-1 lg:grid-cols-2">
        <AssistentesTable 
          assistants={topAssistants} 
          loading={loading}
        />
        <CampaignsTable 
          campaigns={topCampaigns} 
          loading={loading}
        />
      </div>
    </div>
  );
};

export default Dashboard;